const types = ['success', 'error', 'warning', 'info', 'question']
const defatulTime = 3000

export class MessageAlert {
    private _message: string
    private _type: string
    private _time: number

    constructor (message: string, type: string, time?: number) {
      this._time = defatulTime
      this._message = message
      if (!types.includes(type)) {
        throw new TypeError('Wrong type for alert')
      } else { this._type = type }

      if (time) { this._time = time }
    }

    message (): string {
      return this._message
    }

    type (): 'success' | 'error' | 'warning' | 'info' | 'question' {
      switch (this._type) {
        case 'error':
          return 'error'
        case 'warning':
          return 'warning'
        case 'info':
          return 'info'
        case 'question':
          return 'question'
        case 'success':
        default:
          return 'success'
      }
    }

    time (): number {
      return this._time
    }
}
